import React from 'react';
import { Session, SupabaseClient } from '@supabase/supabase-js';
import { useNavigate } from 'react-router-dom';
import { CreateTeam } from '../components/CreateTeam';
import { showError, showSuccess } from '../lib/alerts';

interface OnboardingPageProps {
  supabase: SupabaseClient;
  session: Session;
}

export default function OnboardingPage({ supabase, session }: OnboardingPageProps) {
  const navigate = useNavigate();

  async function handleSignOut() {
    try {
      await supabase.auth.signOut();
      showSuccess('Signed out successfully');
      navigate('/login', { replace: true });
    } catch (err) {
      showError(err instanceof Error ? err.message : 'Sign out failed');
    }
  }

  return (
    <CreateTeam
      supabase={supabase}
      session={session}
      onBack={() => navigate('/login')}
      onSignOut={handleSignOut}
    />
  );
}